
import { required, email } from 'vuelidate/lib/validators'

export default {
  rental: {
    tower_id: {
      required
    },
    unit_id: {
      required
    },
    garage_id: {
      required
    },
    guest_name: {
      required
    },
    guest_email: {
      required,
      email
    },
    phone: {
      required
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/rental/form/resources/validations.js